// extracted by mini-css-extract-plugin
export default {"maintext":"ProfessionSection_maintext__R0Stj","description":"ProfessionSection_description__mQ1sX","email":"ProfessionSection_email__GlVrk"};